import { useContext } from 'react';
import { useNavigate } from 'react-router';
import {
	IncidentDrawerContext,
	defaultContext,
	type IncidentDrawerContextType,
} from './IncidentDrawerContextStore';

export const useIncidentDrawer = (): IncidentDrawerContextType => {
	const context = useContext(IncidentDrawerContext);
	const navigate = useNavigate();

	// Handle a fallback when a context is not initialized (for example, inside a chart embedded in another context)
	if (context === defaultContext) {
		return {
			...context,
			openIncident: (incident: string | null) =>
				navigate(`/incident/${incident ?? ''}`),
		};
	}

	return context;
};
